// extracted by css-extract-rspack-plugin
export default {"root":"root-yqmtxH","comment":"comment-vxS_SD","avatar":"avatar-NwHqAG","count":"count-S7jqgq","respondBtn":"respondBtn-aWFy0L"};